






























































































































































































import { Dialog, Button, Popover, Upload } from 'element-ui'
import { Vue, Component, Ref, Watch } from 'vue-property-decorator'

import AddCreditCardForm from '@/components/AddCreditCardForm.vue'
import ChangePasswordForm from '@/components/ChangePasswordForm.vue'
import CreditCardItem from '@/components/CreditCardItem.vue'
import CustomerSubscriptionsForm from '@/components/CustomerSubscriptionsForm.vue'
import EmergencyContactDetailsForm from '@/components/EmergencyContactDetailsForm.vue'
import LargeAvatar from '@/components/LargeAvatar.vue'
import ListWithIcons from '@/components/ListWithIcons.vue'
import LoadingPlaceholder from '@/components/LoadingPlaceholder.vue'
import ConfirmationModal from '@/components/modals/ConfirmationModal.vue'
import RemoveCreditCardModal from '@/components/modals/RemoveCreditCardModal.vue'
import PersonalDetailsForm from '@/components/PersonalDetailsForm.vue'

import ChangePasswordFormModel from '@/models/change-password-form'
import CreditCard from '@/models/credit-card'
import ErrorEntities from '@/models/error-entities'
import NewCreditCardForm from '@/models/new-credit-card-form'

import { AddCreditCardModalMutationTypes } from '@/store/modules/addCreditCardModal'
import { AuthActionTypes } from '@/store/modules/auth/actions'
import { ChangePasswordModalMutationTypes } from '@/store/modules/changePasswordModal'
import { CreditCardActionTypes } from '@/store/modules/credit-cards'
import {
  CustomerActionTypes,
  CustomerMutationTypes,
} from '@/store/modules/customer'
import { StripeActionTypes } from '@/store/modules/stripe'

@Component({
  components: {
    CustomerSubscriptionsForm,
    EmergencyContactDetailsForm,
    PersonalDetailsForm,
    CreditCardItem,
    AddCreditCardForm,
    LargeAvatar,
    ChangePasswordForm,
    ConfirmationModal,
    RemoveCreditCardModal,
    LoadingPlaceholder,
    ListWithIcons,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    [Popover.name]: Popover,
    [Upload.name]: Upload,
  },
})
export default class Profile extends Vue {
  @Ref() readonly changePasswordFormRef!: ChangePasswordForm
  @Ref() readonly addCreditCardFormRef!: AddCreditCardForm
  @Ref() readonly personalDetailsFormRef!: PersonalDetailsForm
  @Ref() readonly emergencyContactDetailsFormRef!: EmergencyContactDetailsForm
  @Ref() readonly submitButton!: Button
  @Ref() readonly avatarPopoverRef!: any

  cardToDeleteId: number | null = null
  personalDetailsData = {}
  emergencyContactData = {}
  showAvatarUploadPopover = true
  isUpdating = false

  get customer() {
    return this.$store.getters.getCurrentCustomer
  }

  get errors(): ErrorEntities {
    return this.$store.state.customer.errors
  }

  get creditCards(): CreditCard[] {
    return this.$store.getters.getCreditCards
  }

  get cardToDelete(): CreditCard | null {
    return this.$store.getters.getCreditCardById(this.cardToDeleteId)
  }

  get stripeSdkLoaded(): boolean {
    return this.$store.getters.getStripeSdkLoaded
  }

  get addCardModalVisible() {
    return this.$store.getters.getAddCreditCardModalVisible
  }

  set addCardModalVisible(value: boolean) {
    this.$store.commit(AddCreditCardModalMutationTypes.Toggle, value)
  }

  get addCardErrors() {
    return this.$store.getters.getAddCreditCardModalErrors
  }

  get changePasswordModalVisible() {
    return this.$store.getters.getChangePasswordModalVisible
  }

  get changePasswordModalErrors() {
    return this.$store.getters.getChangePasswordModalErrors
  }

  get customerLoaded(): boolean {
    return !!this.customer
  }

  get avatarListItems(): any[] {
    return [
      {
        iconClass: 'sc-icon-camera',
        type: 'component',
        item: 'el-upload',
        props: {
          action: '#',
          showFileList: false,
          beforeUpload: (file: any) => this.beforeAvatarUpload(file),
          innerText: 'Upload Photo',
        },
      },
      {
        iconClass: 'sc-icon-bin',
        item: 'Remove Current Photo',
        click: () => {
          this.onRemoveAvatarPictureClick()
        },
      },
    ]
  }

  get avatarIsLoading(): boolean {
    return this.$store.getters.avatarIsLoading
  }

  @Watch('addCardModalVisible')
  onAddCreditCardModalOpen(value: boolean, oldValue: boolean) {
    if (oldValue && !value) {
      this.addCreditCardFormRef.resetForm()
    }
  }

  async onCustomerUpdate() {
    if (this.isUpdating) {
      return
    }

    this.isUpdating = true
    const personalDetailsForm: any = this.personalDetailsFormRef
    const emergencyForm: any = this.emergencyContactDetailsFormRef

    try {
      if (
        personalDetailsForm &&
        typeof personalDetailsForm.validate === 'function'
      ) {
        await personalDetailsForm.validate()
      }

      if (emergencyForm && typeof emergencyForm.validate === 'function') {
        await emergencyForm.validate()
      }

      await this.$store.dispatch(CustomerActionTypes.UpdateCustomerDetails, {
        profile: this.personalDetailsData,
        emergency: this.emergencyContactData,
      })
      ;(this.submitButton.$el as HTMLElement).blur()
    } catch (err) {
      console.error('Update failed:', err)
    } finally {
      this.isUpdating = false
    }
  }

  resetForm() {
    this.personalDetailsFormRef.fillInForm()
    this.emergencyContactDetailsFormRef.fillInForm()
  }

  onEmergencyContactUpdate(updates: { [field: string]: any }) {
    this.$store.dispatch(CustomerActionTypes.UpdateEmergencyContact, updates)
  }

  onLogout() {
    this.$store.dispatch(AuthActionTypes.Logout)
  }

  onCardDeleteClick(cardId: number) {
    this.cardToDeleteId = cardId
  }

  onCardDelete() {
    this.$store.dispatch(CreditCardActionTypes.DeleteCard, this.cardToDeleteId)
    this.cardToDeleteId = null
  }

  openAddCreditCardModal() {
    this.$store.commit(AddCreditCardModalMutationTypes.Open)
  }

  onCreditCardCreate(newCard: NewCreditCardForm) {
    this.$store.dispatch(CreditCardActionTypes.AddCard, newCard)
  }

  onChangePasswordModalOpen() {
    this.changePasswordFormRef && this.changePasswordFormRef.resetForm()
    this.$store.commit(ChangePasswordModalMutationTypes.Open)
  }

  onChangePasswordModalClose() {
    this.$store.commit(ChangePasswordModalMutationTypes.Close)
  }

  onPasswordChange(changePasswordForm: ChangePasswordFormModel) {
    this.$store.dispatch(CustomerActionTypes.ChangePassword, changePasswordForm)
  }

  onRemoveAvatarPictureClick() {
    this.$store.dispatch(CustomerActionTypes.RemoveAvatar)
    this.avatarPopoverRef.doClose()
  }

  handleMarketingSubscriptionClick(isSubscriptionActive: boolean) {
    this.$store.dispatch(
      CustomerActionTypes.ManageSubscription,
      isSubscriptionActive,
    )
  }

  beforeAvatarUpload(image: File) {
    const isJPG = image.type === 'image/jpeg'
    const validSize = image.size / 1024 / 1024 < 2

    // TODO: Currently not working, figure out why
    if (!isJPG) {
      this.$store.commit(
        CustomerMutationTypes.UpdateAvatarError,
        'Avatar picture must be JPG format',
      )
    } else if (!validSize) {
      this.$store.commit(
        CustomerMutationTypes.UpdateAvatarError,
        'Avatar picture size can not exceed 2MB!',
      )
    } else {
      this.$store.dispatch(CustomerActionTypes.UpdateAvatar, image)
    }

    this.avatarPopoverRef.doClose()
  }

  created() {
    this.$store.dispatch(CreditCardActionTypes.Query)
    this.$store.dispatch(StripeActionTypes.LoadSdk)
  }
}
